import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actionCreators as StudnetCreator } from "../../store/student";
import MDBDataTableV5 from '../CustomDataTable';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Line from './Chart/Line';



export default function ReinforcementsDetails() {
  const dispatch: Dispatch<any> = useDispatch();
  const { id } = useParams<{ id?: string }>();
  const students = useSelector((state: any) => state.Student.students);
  const student = students?.find((st: any) => st.id == id);
  const guardian = useSelector((state: any) => state.Parent.guardian);

  const [reinforcementsData, setReinforcementsData] = useState<any>({
    columns: [
      {
        label: "Reinforcement point",
        field: "pointname",
      },
      {
        label: "Points",
        field: "points",
      },
      {
        label: "Teacher name",
        field: "displayname",
      },
      {
        label: "Date",
        field: "date",
      },
    ],
    rows: [],
  });

  useEffect(() => {
    if (guardian?.id) {
      dispatch(StudnetCreator.GetStudents({ id: guardian.id }));
    }
  }, [dispatch, guardian?.id]);

  useEffect(() => {
    if (student?.Reinforcements) {
      const formattedRows = student.Reinforcements.map((r: any) => {
        const score = r.student_points ?? r.points;
        const numScore = Number(score);
        const isPositive = numScore > 0;

        return {
          ...r,
          pointname: r.pointname || "-",
          points: (
            <span
              className={`badge ${isPositive ? "bg-success text-white" : "bg-danger text-white"}`}
              style={{
                backgroundColor: isPositive ? "#28a745" : "#dc3545",
                color: "#ffffff",
                fontSize: "13px",
                padding: "4px 10px",
                fontWeight: "bold",
                borderRadius: "4px",
                display: "inline-block",
              }}
            >
              {isPositive ? `+${score}` : score}
            </span>
          ),
          displayname: r.displayname || "-",
          date: r.date || "-",
        };
      });

      setReinforcementsData((old: any) => ({
        ...old,
        rows: formattedRows,
      }));
    } else {
      setReinforcementsData((old: any) => ({
        ...old,
        rows: [],
      }));
    }
  }, [student]);

  const overallRP = (student?.Reinforcements || []).reduce((sum: number, r: any) => {
    return sum + Number(r.student_points ?? r.points ?? 0);
  }, 0);

  return (
    <div className="row">
      <div className="text-primary">
        {student ? (
          <h3 className="mb-4">
            {student.fullname} :{" "}
            <small style={{ fontStyle: "italic" }}>
              {student.id} : {student.grade}
            </small>
          </h3>
        ) : null}
      </div>
      <Card className="w-100">
        <CardHeader>
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap">
            <h4 className="title mb-0">Reinforcement Points</h4>
            <div className="d-flex align-items-center" style={{ fontSize: "18px" }}>
              <span className="me-2 mr-2" style={{ fontWeight: 600, color: "#555" }}>
                Overall RP:
              </span>
              <span
                className={`badge ${
                  overallRP > 0 ? "bg-success" : overallRP < 0 ? "bg-danger" : "bg-secondary"
                }`}
                style={{
                  backgroundColor:
                    overallRP > 0 ? "#28a745" : overallRP < 0 ? "#dc3545" : "#6c757d",
                  color: "#ffffff",
                  fontSize: "16px",
                  padding: "5px 12px",
                  fontWeight: "bold",
                  borderRadius: "6px",
                }}
              >
                {overallRP > 0 ? `+${overallRP}` : overallRP}
              </span>
            </div>
          </div>
          <Line color="blue" Reinforcements={student?.Reinforcements} />
        </CardHeader>
        <CardBody className="all-icons">
          <MDBDataTableV5
            hover
            responsive
            bordered
            striped
            data={reinforcementsData}
          />
        </CardBody>
      </Card>
    </div>
  );
}